// @flow
import React, { type Node } from 'react';
import { Box, Button, Divider, HelpTip, Icons, Text, Stack } from 'sarsaparilla';
import moment from 'moment-timezone'
import cx from 'classnames';
import { QUEUING_LOTTERY_RANGE_FORMAT, QUEUING_LOTTERY_STATUS, type QueueLottery } from 'ui-queuing-lottery'

import { type PermitType } from '../types'

type PropTypes = {
    lotteries: QueueLottery[],
    onEnterLottery?: (QueueLottery) => void,
    permit: PermitType,
    futureLotteryTitle: string,
    isFutureLottery: boolean,
}

export default function QueuingLotteryWidget({
    permit,
    lotteries,
    onEnterLottery,
    futureLotteryTitle,
    isFutureLottery,
}: PropTypes) {
    function formatDate(stringDate) {
        return moment(stringDate).format(QUEUING_LOTTERY_RANGE_FORMAT)
    }

    function formatDateTime(stringDate) {
        return moment.tz(stringDate, permit?.time_zone).format(`${QUEUING_LOTTERY_RANGE_FORMAT} | h:mm A zz`)
    }
    const lotteriesToRender = lotteries.map<Node>((lottery, index) => {
        const isOpen = lottery.status === QUEUING_LOTTERY_STATUS.Open
        return (
            <Box key={lottery.lottery_id}>
                {index > 0 && (
                    <Box className={cx("mb-2", {
                        "rec-aside-subheader": isOpen,
                        "rec-aside-subheader-gray": !isOpen,
                    })} >
                        <div>{isOpen ? 'Early Access Lottery' : 'Future Lottery'}</div>
                    </Box>
                )}

                {isOpen ? (
                    <>
                        <Text fontWeight="semibold">
                            Application Deadline
                        </Text>
                        <Text>
                            {formatDateTime(lottery.close_time)}
                        </Text>
                    </>
                ) : (
                    <>
                        <Text fontWeight="semibold">
                            Application Opens
                        </Text>
                        <Text>
                            {formatDateTime(lottery.open_time)}
                        </Text>
                    </>
                )}

                <Divider />
                <Text fontWeight="semibold">
                    Lottery Results Available
                </Text>
                <Text>
                    {formatDate(lottery.announce_time)} (Estimated)
                </Text>

                <Divider />
                <Text fontWeight="semibold">
                    Early Access Period
                    <HelpTip
                        tipForDescriptor="Help Tip for Early Access Period"
                        maxWidth={260}
                        content="Successful lottery applicants may view real-time inventory availability as soon as the Early Access Period opens. Successful applicants may attempt to make a reservation beginning on their access window date and time." />
                </Text>
                <Text>
                    {formatDate(lottery.eap_start)} - {formatDate(lottery.eap_end)}
                </Text>

                <Divider />
                <Text>
                    This lottery provides an opportunity to access permit inventory early and book a reservation during the peak season:
                </Text>
                <Text fontWeight="semibold">
                    {formatDate(lottery.trip_range_start)} - {formatDate(lottery.trip_range_end)}
                </Text>

                {isOpen && (
                    <Button className="mt-2" shouldFitContainer onClick={onEnterLottery ? () => onEnterLottery(lottery) : undefined}>
                        Register for Open Lottery
                    </Button>
                )}
            </Box>
        )
    });

    return (
        <Stack className="right-rail-card">
            {futureLotteryTitle && isFutureLottery && (
                <div className="rec-aside-subheader-gray">
                    <div>{futureLotteryTitle}</div>
                </div>
            )}
            {lotteriesToRender}
            {lotteriesToRender?.length > 0 && (
                <Box className="rec-form-item-wrap-full">
                    <Button
                        appearance="link"
                        shouldFitContainer
                        iconBeforeElement={<Icons.IconHelp />}
                        href="/lottery/how-they-work">
                        How Does the Lottery Work?
                    </Button>
                </Box>
            )}
        </Stack>
    )
}
